export default __webpack_public_path__ + "static/media/Zerodha.f4e71ff2.svg";